export const isAppleDevice = () => {
  // @ts-expect-error TS libdom is out of date and does not have userAgentData
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgentData
  const platform = window?.navigator?.platform ?? window?.navigator?.userAgentData?.platform ?? '';

  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};